module.exports = __webpack_public_path__ + "static/media/fillLevel.f4d6b6ec.png";